import { SET_INDEXEDDB_TABLES } from "./parameterConstants";

export function parameter(state = [], action) {
    switch (action.type) {
        default:
            return state;
    }
}

export function indexedDbTables(state = [], action) {
    switch (action.type) {
        case SET_INDEXEDDB_TABLES:
            return action.indexedDbTables;

        default:
            return state;
    }
}
